import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ButtonComponent from '../Button/Button';

const useStyles = makeStyles((theme) => ({
    title: {
        fontSize: theme.typography.pxToRem(24)
    },
    content: {
        minWidth: 600,
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            minWidth: 0
        }
    },
}));

/**
 * Implementación del componente genérico de modal.
 * @param {Object} props - Propiedades del componente.
 * @param {Boolean} props.open - El estado del modal. 
 * @param {Function} props.handleClose - Cambia el estado del modal. 
 * @param {String} props.title - Título del modal. 
 * @param {Boolean} [props.hasForm=false] - Indica si el modal contiene un formulario. 
 * @param {Function} props.onSubmit - Callback que se realiza en el evento del formulario. 
 * @param {React.Component} props.action - Componente react para el boton de submit. 
 * @returns {React.Component}
 */
export default function Modal({ open, handleClose, title, hasForm = false, onSubmit, action, children }) {

    const classes = useStyles();

    const handleSubmit = event => {
        event.preventDefault();
        if(onSubmit) onSubmit();
    }

    const render = () => {
        return <>
            <DialogContent className={classes.content}>
                <DialogContentText>
                    {children}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <ButtonComponent withBorder={!action} onClick={handleClose} color="primary">Cerrar</ButtonComponent>
                {action && action}
            </DialogActions>
        </>
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>
                <Typography component="h2" className={classes.title}>{title}</Typography>
            </DialogTitle>
            {hasForm ? <form onSubmit={handleSubmit}>{render()}</form> : render()}
        </Dialog>
    )
}
